/**
 * Alshallal Pastry Company HR System - Placeholder Pages
 * Pages to be implemented in future phases
 */
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Building2, 
  Users, 
  FileText, 
  Calendar, 
  ClipboardList,
  Settings,
  Shield,
  User
} from 'lucide-react';

const PlaceholderPage = ({ icon: Icon, titleKey, descriptionEn, descriptionAr }) => {
  const { t, isRTL } = useLanguage();
  
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="p-4 bg-slate-100 rounded-full w-fit mx-auto mb-6">
            <Icon className="h-10 w-10 text-slate-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-3">
            {t(titleKey)}
          </h1>
          <p className="text-slate-600">
            {isRTL ? descriptionAr : descriptionEn}
          </p>
          <p className="text-sm text-slate-400 mt-4">
            {isRTL ? 'قيد التطوير - المرحلة القادمة' : 'Coming soon - Next phase'}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export const EmployeesPage = () => (
  <PlaceholderPage 
    icon={Building2}
    titleKey="employees"
    descriptionEn="Employee management will be implemented in Phase 2"
    descriptionAr="سيتم تنفيذ إدارة الموظفين في المرحلة الثانية"
  />
);

export const UsersPage = () => (
  <PlaceholderPage 
    icon={Users}
    titleKey="users"
    descriptionEn="User management interface will be available soon"
    descriptionAr="ستكون واجهة إدارة المستخدمين متاحة قريباً"
  />
);

// DocumentsPage moved to /pages/documents/

// LeavePage moved to /pages/leave/

export const RequestsPage = () => (
  <PlaceholderPage 
    icon={ClipboardList}
    titleKey="requests"
    descriptionEn="Request management will be implemented in Phase 5"
    descriptionAr="سيتم تنفيذ إدارة الطلبات في المرحلة الخامسة"
  />
);

export const SettingsPage = () => (
  <PlaceholderPage 
    icon={Settings}
    titleKey="settings"
    descriptionEn="Settings and preferences"
    descriptionAr="الإعدادات والتفضيلات"
  />
);

export const SystemPage = () => (
  <PlaceholderPage 
    icon={Shield}
    titleKey="system"
    descriptionEn="System administration panel for Super Admins"
    descriptionAr="لوحة إدارة النظام للمسؤولين"
  />
);

export const ProfilePage = () => (
  <PlaceholderPage 
    icon={User}
    titleKey="profile"
    descriptionEn="View and edit your profile"
    descriptionAr="عرض وتعديل ملفك الشخصي"
  />
);

export const NotFoundPage = () => {
  const { isRTL } = useLanguage();
  
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-slate-300 mb-4">404</h1>
        <p className="text-xl text-slate-600">
          {isRTL ? 'الصفحة غير موجودة' : 'Page not found'}
        </p>
      </div>
    </div>
  );
};
